/* eslint-disable max-lines */
import { get } from 'lodash';
import app from '../../../scripts/app';
import template from './description-and-photos.jade';
import validation from '../../../scripts/services/validation';
import { initializePhotoUploadTracking } from './utils/photo-tracking';

import { initializeHintClickTracking } from '../../../scripts/utils/hint-tracking';
import { initializeScrollListeners } from './utils/scroll-listeners';
import { selectConfigValue } from '../../../../../shared/selectors/config';
import { selectAnalyticsOfferStatus } from '../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../shared/utils/tracking/requiredFields';
import configsByCategoryForAreaPart from '../../../scripts/segment-inputs-config/configs-by-category/commercial-area-parts-v2';

app
  .directive('cianAfDescriptionAndPhotos', [
    () => {
      return {
        template,
        scope: {},
        bindToController: {
          ad: '=',
          dealType: '=',
          propertyType: '=',
          rentDuration: '=',
          objectType: '=',
          category: '=',
        },
        require: ['cianAfDescriptionAndPhotos', '^^form'],
        link: (scope, element, attrs, [cianAfDescriptionAndPhotos, ngFormCtrl]) => {
          cianAfDescriptionAndPhotos.init(ngFormCtrl);

          scope.$watch(
            () => cianAfDescriptionAndPhotos.ad.category,
            category => {
              cianAfDescriptionAndPhotos.setBannerValue(category);
            },
          );
        },
        controller: [
          '$scope',
          'store',
          'config',
          'categoryService',
          'descriptionAndPhotosService',
          'addressService',
          'geoService',
          'userService',
          'httpResponseErrorService',
          'isSimpleFormEnabled',
          'homeownerService',
          'adTooltipsService',
          '$document',
          '$rootScope',
          '$filter',
          'PhotoUploadService',
          '$timeout',
          'analyticsService',
          'deviceService',
          'popupService',
          'formIdService',
          function (
            $scope,
            store,
            config,
            categoryService,
            descriptionAndPhotosService,
            addressService,
            geoService,
            userService,
            httpResponseErrorService,
            isSimpleFormEnabled,
            homeownerService,
            adTooltipsService,
            $document,
            $rootScope,
            $filter,
            PhotoUploadService,
            $timeout,
            analyticsService,
            deviceService,
            popupService,
            formIdService,
          ) {
            this.isMobile = deviceService.isMobile;
            this.photosTooltipText = '';
            this.descriptionTooltipText = '';
            this.videosTooltipText = '';
            this.photoUrl = '/addform/v2/images/';
            this.ad.photos = this.ad.photos || [];

            this.showPhotoViolationWarning = !!window.addFormState.photoModerationViolation;
            this.showVideoViolationWarning = !!window.addFormState.videoModerationViolation;
            this.photoViolationTitle = get(window.addFormState, 'photoModerationViolation.title', '');
            this.photoViolationComment = get(window.addFormState, 'photoModerationViolation.comment', '');
            this.videoViolationTitle = get(window.addFormState, 'videoModerationViolation.title', '');
            this.videoViolationComment = get(window.addFormState, 'videoModerationViolation.comment', '');
            this.photoShowMore = false;
            this.videoShowMore = false;
            this.commentCharLimit = 290;

            this.photoCommentLengthExceeded = this.photoViolationComment.length > this.commentCharLimit;
            this.videoCommentLengthExceeded = this.videoViolationComment.length > this.commentCharLimit;

            this.descriptionMaxLength = 3000;
            this.titleMaxLength = 33;
            this.titleMinLength = 8;

            this.isHideYoutubeFeatureEnabled = config.get('hideYoutubeVideo') || false;

            this.getPhotoComment = () => {
              return this.photoShowMore
                ? this.photoViolationComment
                : this.photoViolationComment.slice(0, this.commentCharLimit);
            };

            this.getVideoComment = () => {
              return this.videoShowMore
                ? this.videoViolationComment
                : this.videoViolationComment.slice(0, this.commentCharLimit);
            };

            this.togglePhotoShowMore = () => {
              this.photoShowMore = !this.photoShowMore;
            };

            this.toggleVideoShowMore = () => {
              this.videoShowMore = !this.videoShowMore;
            };

            this.openVideoHintModal = () => {
              popupService.openPopup('hint', {
                text: this.videosTooltipText,
                title: 'Видео',
                hideCloseButton: false,
              });
            };

            this.openDescriptionHintModal = () => {
              popupService.openPopup('hint', {
                text: this.descriptionTooltipText,
                title: 'Как составить правильное описание',
                hideCloseButton: false,
              });
            };

            this.openPhotoHintModal = () => {
              popupService.openPopup('hint', {
                text: this.photosTooltipText,
                title: `${this.bannerValue} просмотров у объявлений с фото`,
                hideCloseButton: false,
              });
            };

            const photoValidationMessages = {
              required: 'Загрузите фотографии',
              maxFiles: 'Загрузите не более 50 фотографий',
            };

            this.unsubscribeHintListener = null;

            $scope.$on('$destroy', () => {
              if (this.unsubscribeHintListener) {
                this.unsubscribeHintListener();
              }
            });

            const interceptorListener = httpResponseErrorService.addToSkip(config => {
              return config.url.indexOf(this.photoUrl) !== -1;
            });

            this.setBannerValue = category => {
              const categoryInfo = categoryService.getInfoByCategory(category);
              this.bannerValue = categoryInfo.dealType === 'rent' ? '100' : '50';
            };

            this.isRequired = () => {
              return this.minPhotoCount > 0;
            };

            // Для собственников меняем текст кнопки загрузки фото в блоке "Описание и фото"
            $scope.$watchGroup(
              [
                () => this.ad.isByHomeowner,
                () => $document[0].querySelector('.cui-photo-upload__description button span'),
                () => this.isMultiAd(),
              ],
              values => {
                const isByHomeowner = values[0];
                const btn = values[1];
                if (btn) {
                  if (this.isMultiAd()) {
                    btn.textContent = 'Выберите файлы';

                    return;
                  }

                  btn.textContent = isByHomeowner ? 'Добавить фото и планировку' : 'Выберите файлы на компьютере';
                }
              },
            );

            /**
             * Проверяет минимальное кол-во фото, установленное сервером для данного пользователя, категории и адресса
             * и применяет его, если оно больше дефолтного.
             */
            const checkMinPhotoCount = () => {
              if (this.ad.category && this.dealType === 'rent' && userService.isAuthenticated) {
                // Запрос на получения минимального необходимого количества фотографий кешируется.
                descriptionAndPhotosService
                  .getMinPhotoCount(this.ad.category, geoService.getLocationPath())
                  .then(count => setMinCount(count));
              }
            };

            this.isHintTrackingInitialized = false;
            let isTooltipsListenersInitialized = false;
            let unsubscribeOldListeners = null;

            const updateTooltips = isListenersMustUpdated => {
              if (!this.ad.category) {
                return;
              }

              if (isListenersMustUpdated && unsubscribeOldListeners) {
                unsubscribeOldListeners();

                unsubscribeOldListeners = null;

                isTooltipsListenersInitialized = false;
              }

              this.photosTooltipText = '';
              this.descriptionTooltipText = '';
              this.videosTooltipText = '';

              adTooltipsService.getCategoryTooltips(this.ad.category, this.ad.isByHomeowner).then(tooltips => {
                this.videosTooltipText = tooltips['videos'] || '';
                this.photosTooltipText = tooltips['photos'] || '';
                this.descriptionTooltipText = tooltips['description'] || '';

                if (!this.isHintTrackingInitialized) {
                  setTimeout(
                    () =>
                      (this.unsubscribeHintListener = initializeHintClickTracking(
                        'video-hint',
                        analyticsService.adAnalyticsCategory,
                      )),
                    0,
                  );
                }

                this.isHintTrackingInitialized = true;

                if (!isTooltipsListenersInitialized) {
                  setTimeout(() => {
                    unsubscribeOldListeners = initializeScrollListeners(analyticsService.adAnalyticsCategory);
                  }, 0);
                }

                isTooltipsListenersInitialized = true;
              });
            };

            this.isMultiAd = () => {
              const hasMultiAdBlock = configsByCategoryForAreaPart[this.ad.category];

              return Boolean(this.ad.areaParts && hasMultiAdBlock);
            };

            // Применяет минимальное кол-во фото и соотв. месседж
            const setMinCount = (minCount = 0) => {
              const isMultiAds = this.isMultiAd();
              const defaultMinCount =
                this.dealType === 'rent' && this.propertyType === 'residential' && this.rentDuration === 'short'
                  ? 3
                  : 0;
              this.minPhotoCount = Math.max(defaultMinCount, minCount);

              let validationMessage = `Разместите не менее ${this.minPhotoCount}\r\nфотографий интерьера\r\nбез водяных знаков\r\nи меток`;

              if (minCount > defaultMinCount) {
                validationMessage = isMultiAds
                  ? `Для некоммерческого тарифа\r\nв разделе «Аренда» нужно\r\nминимум ${this.minPhotoCount} фотографий здания`
                  : `При публикации\r\nв раздел "Аренда"\r\nна некоммерческом\r\nтарифе необходимо\r\nзагрузить не менее ${this.minPhotoCount}\r\nфотографий`;
              }

              photoValidationMessages.minCount = validationMessage;
            };

            // применяем дефолтное ограничение кол-ва фото
            setMinCount();

            $scope.$watch(() => this.ad.category, checkMinPhotoCount);
            $scope.$watch(() => this.ad.areaParts, checkMinPhotoCount);
            $scope.$watch(
              () => this.ad.category,
              () => updateTooltips(true),
            );
            $scope.$watch(
              () => this.ad.isByHomeowner,
              () => updateTooltips(true),
            );

            $scope.$on('user.setUser', checkMinPhotoCount);
            $scope.$on('geo.address.changed', checkMinPhotoCount);
            $scope.$on('$destroy', interceptorListener);
            $rootScope.$on('address.geoObjectProcessed', () => {
              checkDescriptionRequired();
            });
            $rootScope.$on('address.validated', (event, valid) => {
              if (valid) {
                checkDescriptionRequired();
              }
            });

            this.photoErrors = [];

            initializePhotoUploadTracking({
              controller: this,
              $rootScope,
              $timeout,
              $scope,
              trackingCategory: analyticsService.adAnalyticsCategory,
              PhotoUploadService,
              formIdService,
              config,
            });

            this.init = form => {
              this.form = form;

              this.errors = [];

              this.getErrorMessage = file => {
                const errorMessage = {
                  minWidth: `Ширина изображения ${file.name} меньше 200px`,
                  minHeight: `Высота изображения ${file.name} меньше 200px`,
                  badWH: `Не рекомендуем использовать "${file.name}": его разрешение менее 800х600px`,
                  pattern: `Файл ${file.name} не является изображением`,
                  maxSize: `Файл ${file.name} превышает 10 МБ`,
                  uploadError: 'Ошибка загрузки, пожалуйста, повторите позднее',
                };

                return errorMessage[file.$error || file.$warning];
              };

              this.photosValidation = validation(form, 'photos', photoValidationMessages);

              this.descriptionValidation = validation(form, 'description', {
                maxlength: 'Превышена максимальная длина описания',
                required: 'Описание должно содержать не менее 15 буквенных символов',
                descriptionIsText: 'Описание должно содержать не менее 15 буквенных символов',
              });

              this.titleValidation = validation(form, 'title', {
                titleIsText: 'Неправильно заполнено поле',
                titleNotCopy: 'В заголовке должен быть использован только уникальный текст',
                titleMinLength: `Не менее ${this.titleMinLength} символов (без знаков препинания и пробелов)`,
                maxlength: 'Превышена максимальная длина описания',
              });
            };

            this.isVideoFieldVisible = () => {
              return (
                !this.isHideYoutubeFeatureEnabled &&
                ((this.ad.category !== 'newBuildingFlatSale' && !isSimpleFormEnabled()) ||
                  this.ad.category === 'flatSale' ||
                  this.dealType === 'rent')
              );
            };

            this.getPhotoTitle = () => {
              if (this.isMultiAd()) {
                return 'Общие фотографии здания';
              }

              return 'Фотографии';
            };

            this.getPhotoDescription = () => {
              if (this.isMultiAd()) {
                return 'Добавьте актуальные фотографии здания: вид с улицы, двор, ресепшн, вид с террасы и так далее. Нельзя добавлять чужие фото, фото с водяными знаками и рекламные материалы. На фото не должно быть людей, животных, алкоголя, табака, оружия.\n\nЗагрузите или перетащите сюда до 10 файлов JPG, PNG или GIF до 10 Мб каждый';
              }

              return 'Не допускаются к размещению фотографии с водяными знаками, чужих объектов и рекламные баннеры. JPG, PNG или GIF. Максимальный размер файла 10 мб';
            };

            updateTooltips();

            /* формируем плейсхолдер по состоянию объявления собственника*/
            const getDescriptionPlaceholderByOfferConditions = (dealType, objectType, rentDuration) => {
              /*аренда*/
              if (dealType === 'rent') {
                if (rentDuration === 'short') {
                  /*посуточно*/
                  return (
                    'Расскажите в каком состоянии объект, мебель; кого вы хотите видеть в жильцах, готовы ли к домашним животным; ' +
                    'инфраструктура около дома, дополнительные платежи.'
                  );
                }

                /*длительно*/
                return (
                  'Расскажите в каком состоянии объект, мебель, можно ли изменять интерьер; ' +
                  'кого вы хотите видеть в жильцах, готовы ли к домашним животным; ' +
                  'инфраструктура около дома, дополнительные платежи (счетчики и т.д.).'
                );
              }
              /*продажа*/
              if (dealType === 'sale') {
                /* квартира, комната, доля в квартире */
                if (['flat', 'room', 'flatShare'].includes(objectType)) {
                  return (
                    'Расскажите в каком состоянии полы, окна, сантехника, установлены ли счетчики; была ли перепланировка; ' +
                    'как долго квартира в собственности и сколько хозяев; какие у вас соседи.'
                  );
                }
                /* дом/дача, таунхаус, часть дома, коттедж*/
                if (['house', 'townhouse', 'houseShare', 'cottage'].includes(objectType)) {
                  return (
                    'Расскажите в каком состоянии полы, окна, сантехника, установлены ли счетчики; ' +
                    'как долго объект в собственности и сколько хозяев; какие у вас соседи.'
                  );
                }
              }

              /*участок и другие неподходящие типы недвижимости*/
              return '';
            };

            this.getDescriptionPlaceholder = () => {
              if (
                (homeownerService.userCanPublishThisOfferAsHomeowner && this.propertyType !== 'commercial') ||
                this.ad.isByHomeowner
              ) {
                //пользователь залогинен как собственник и некоммерческая недвижимость или выбран тип аккаунта собственник(доступна только жилая)

                return getDescriptionPlaceholderByOfferConditions(this.dealType, this.objectType, this.rentDuration);
              }

              /* не собственник */
              return '';
            };

            this.isDescriptionRequired = false;

            const state = store.getState();

            const descriptionRequiredRegions = selectConfigValue('descriptionRequiredRegions', state);

            const checkDescriptionRequired = () => {
              this.isDescriptionRequired =
                addressService.geoObject &&
                Array.isArray(addressService.geoObject.locationPath) &&
                addressService.geoObject.locationPath.some(location => descriptionRequiredRegions.includes(location));
            };

            checkDescriptionRequired();

            this.getTitleCounter = () => {
              if (!this.ad.title) {
                return;
              }

              const counter = this.titleMaxLength - this.ad.title.replace(/\r(?!\n)|\n(?!\r)/g, '\r\n').length;

              return counter > 0 ? $filter('number')(counter) : 0; // 0 для отрицательных значений
            };

            let trackedValue;

            this.handleBlur = () => {
              const value = this.ad.description;

              if (value && value !== trackedValue) {
                const state = store.getState();
                const category = selectAnalyticsOfferStatus(state);

                trackRequiredFieldFill(category, 'description');
                trackedValue = value;
              }
            };
          },
        ],
        controllerAs: 'descriptionAndPhotos',
        replace: true,
      };
    },
  ])
  .directive('isTitleValid', () => {
    return {
      restrict: 'A',
      require: ['^cianAfDescriptionAndPhotos', 'ngModel', '^^form'],
      link: (scope, element, attrs, [cianAfDescriptionAndPhotos, ngModel, ngFormCtrl]) => {
        ngModel.$validators.titleIsText = value => (value && value.length ? /[a-zA-ZЁёА-я]+/.test(value) : true);
        ngModel.$validators.titleNotCopy = value => {
          if (value && cianAfDescriptionAndPhotos.ad.description) {
            return value.trim() !== cianAfDescriptionAndPhotos.ad.description.trim();
          }

          return true;
        };
        ngModel.$validators.titleMinLength = value => {
          if (value && value.length) {
            // Проверка минимальной длины символов без знаков препинания и пробелов
            return cianAfDescriptionAndPhotos.titleMinLength < value.replace(/[^a-zA-ZЁёА-я0-9]+/g, '').length;
          }

          return true;
        };

        scope.$watch(
          () => cianAfDescriptionAndPhotos.ad.description,
          () => {
            ngFormCtrl.title.$validate();
          },
        );
      },
    };
  })
  .directive('isDescriptionValid', () => {
    return {
      restrict: 'A',
      require: ['^cianAfDescriptionAndPhotos', 'ngModel', '^^form'],
      // eslint-disable-next-line no-unused-vars
      link: (scope, element, attrs, [cianAfDescriptionAndPhotos, ngModel, ngFormCtrl]) => {
        ngModel.$validators.descriptionIsText = value => {
          if (value && value.length) {
            const match = value.match(/[A-Za-zА-Яа-яЁё]/g);

            return !!match && match.length >= 15;
          }

          return false;
        };
      },
    };
  });
